// this utility determines which drawers will be displayed
// with its corresponding item type

export const determineItemProperties = {
  image: [
    'Image',
    'Feather',
    'Opacity',
    'Rotate',
    'Positioning',
    'Border',
    'Drop Shadow',
  ],
  shape: [
    'Shape',
    'Feather',
    'Opacity',
    'Rotate',
    'Positioning',
    'Border',
    'Drop Shadow',
  ],
  text: [
    'Text Box',
    'Opacity',
    'Rotate',
    'Positioning',
    'Border',
    'Text Shadow',
    'Drop Shadow',
  ],
  line: ['Line', 'Opacity', 'Rotate', 'Positioning', 'Border', 'Drop Shadow'],
  qrCode: [
    'Opacity',
    'Feather',
    'Rotate',
    'Positioning',
    'Border',
    'Drop Shadow',
  ],
  editorTextBox: ['Text Box', 'Positioning'],
} as const

export default determineItemProperties
